import { render, staticRenderFns } from "./TaskR.vue?vue&type=template&id=0193885c&scoped=true"
import script from "./TaskR.vue?vue&type=script&lang=ts"
export * from "./TaskR.vue?vue&type=script&lang=ts"
import style0 from "./TaskR.vue?vue&type=style&index=0&id=0193885c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0193885c",
  null
  
)

export default component.exports